/**
 * Work page, the shops — the whole street on one page: every shop in rows,
 * a sidewalk under each row, the categories as districts (filtered with
 * Flip). The markup is the server's
 * (templates/site/sections/work/district.html.twig).
 *
 * @module sections/work/district
 */

import { REDUCED_MOTION } from '../../config.js';
import { $, $$ } from '../../lib/dom.js';
import { Flip, ScrollTrigger, gsap } from '../../lib/gsap.js';

const ALL = 'All';

/**
 * @param {HTMLElement} district
 */
export function animate(district) {
    const buttons = $$('[data-filter]', district);
    const cards = $$('[data-card]', district);
    const label = $('[data-count-label]', district);

    buttons.forEach((button) => {
        button.addEventListener('click', () => {
            const value = button.dataset.filter;
            const state = REDUCED_MOTION ? null : Flip.getState(cards);
            let shown = 0;

            buttons.forEach((other) => other.classList.toggle('is-active', other === button));

            cards.forEach((card) => {
                const match = value === ALL || card.dataset.category === value;
                card.classList.toggle('is-hidden', !match);
                shown += match ? 1 : 0;
            });

            label.textContent = `${shown} shown`;

            if (state) {
                Flip.from(state, {
                    duration: 0.6,
                    scale: true,
                    absolute: true,
                    ease: 'power3.inOut',
                    stagger: 0.03,
                    onEnter: (elements) =>
                        gsap.fromTo(elements, { opacity: 0, scale: 0.94 }, { opacity: 1, scale: 1, duration: 0.45 }),
                    onLeave: (elements) => gsap.to(elements, { opacity: 0, scale: 0.94, duration: 0.28 }),
                    onComplete: () => ScrollTrigger.refresh(),
                });
            }
        });
    });
}
